var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invitation"},[_c('div',{staticClass:"header"},[_vm._v("您正在申请加入：")]),_vm._v(" "),_c('span',{staticClass:"car"},[_vm._v(_vm._s(_vm.storeName))]),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('van-button',{attrs:{"type":"info"},on:{"click":_vm.onOK}},[_vm._v("立即加入")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40829c47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invitation.vue
// module id = 2RNo
// module chunks = 0